import { render, staticRenderFns } from "./Formatos.vue?vue&type=template&id=c1cec3a6&scoped=true&"
import script from "./Formatos.vue?vue&type=script&lang=js&"
export * from "./Formatos.vue?vue&type=script&lang=js&"
import style0 from "./Formatos.vue?vue&type=style&index=0&id=c1cec3a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cec3a6",
  null
  
)

export default component.exports